import { DownloadOutlined } from "@ant-design/icons";
import { Tooltip, Typography } from "antd";
import useWindowSize from "../../api/hooks/useWindowResize";
import { getResource } from "../../helpers/ResourcesHelper";

export function downloadData(data: any, fileName: string, columnsDownload: any) {

  let csvContent = "data:text/plain;charset=utf-8,";
  let csvDataAsRows = data
  if (csvDataAsRows && csvDataAsRows.length > 0) {
    let header = [...Object.keys(csvDataAsRows[0])];


    for (let i = 0; i < csvDataAsRows.length; i++) {
      delete csvDataAsRows[i].Action;
      delete csvDataAsRows[i].Key;


      for (let j = 0; j < header.length; j++) {
        if (header[j].includes('$')) {
          delete csvDataAsRows[i][header[j]];
        }

        if (columnsDownload) {
          let include = columnsDownload.findIndex((c: string) => c.trim() === header[j]);
          if (include < 0) {
            delete csvDataAsRows[i][header[j]];
          }
        }
      }
    }
    let encodedUri = '';
    let link: HTMLElement;

    csvDataAsRows = data != null ?
      data
        .map((e: any) => Object.values(e))
        .reduce(function (csvString: any, row: any) {
          if (Array.isArray(csvString)) {
            csvString = csvString.join('|');
          }
          csvString += "\r\n";
          csvString += row.join('|');
          return csvString;
        }) : [];
    let today = new Date();
    let yearString = today.getFullYear().toString();
    let monthString = (today.getMonth() + 1).toString().padStart(2, '0');
    let dayString = today.getDate().toString().padStart(2, '0');
    let hourString = today.getHours().toString().padStart(2, '0');
    let minuteString = today.getMinutes().toString().padStart(2, '0');
    let timeStamp = yearString + monthString + dayString + hourString + minuteString;

    let newFileName = (fileName ?? 'data_') + timeStamp + ".csv";

    let headerToShow = [];
    for (let j = 0; j < header.length; j++) {
      if (columnsDownload) {
        let include = columnsDownload.findIndex((c: string) => c.trim() === header[j]);
        if (include > -1) {
          headerToShow.push(header[j]);
        }
      }
      else {
        headerToShow.push(header[j]);
      }
    }

    encodedUri = encodeURI(csvContent + headerToShow.join('|') + "\r\n" + csvDataAsRows);
    link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", newFileName);
    link.click();
    document.body.appendChild(link);
  }
}

const DownloadTableRows = (props: any) => {

  const size = useWindowSize();
  return <>
    <Tooltip title={getResource('Message_ExportToExcel')}>
      <Typography.Link
        className="column-actions"
        onClick={() => {
          downloadData(props.data, props.fileName, props.columnsDownload)
        }}
      >
        <DownloadOutlined style={{ fontSize: 18, visibility: (size[0] > 768) ? "visible" : "hidden" }} />
      </Typography.Link>
    </Tooltip>
  </>
}

export default DownloadTableRows;